import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';

import {
    Button,
    Tree,
    Icon,
    message,
    Input
} from 'antd';
import { transformDuplicate } from 'kts-platform-frame/entry/constant/InvoiceType/EnumInvoiceType';
import { MyStore, reducers } from 'kts-platform-frame/redux';
const css = require('./index.scss');
const TreeNode = Tree.TreeNode;
const Search = Input.Search;
const searchStyle = { marginBottom: 32, marginTop: 32, width: 330, height: 32, marginLeft: 39 };

/** Redux接口 */
interface IReduxStatePart {
    userInfo?: any;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    userInfo: state.user.userInfo
}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentWillMount() {
        
        ModulesAction.generateList(this.modulesState.treeDate);
        ModulesAction.getCompanyInfo(this.props.userInfo.companyId);
    }
    public getNewTree = (data) => {
        // let newItem = JSON.parse(Araay.stringify(data));

        const getdate = (newdate) => {
            newdate.forEach((item, index) => {        
                if (item.companyId === this.modulesState.companyId) {
                    addFlag(item); 
                    return;
                } else {
                    if (item.children.length > 0) {
                        getdate(item.children);
                    }
                }
            });
        };
        
        const addFlag = (myitem) => {
            myitem.isCompanyChild = true;
            if (myitem.children.length > 0) {
                myitem.children.map((i) => {
                    addFlag(i);
                });   
            }   
        };
        getdate(data);
        return data;
    }
    render() {
        const companyInfo = this.modulesState.companyInfo;
        return (
            <div className={css['sidebar']}>
                <div className={css['sidebar-header']}>
                    <h1>集团资料</h1>
                </div>
                {this.modulesState.treeDate && <div className={css['sidebar-handler']}>
                    <Search style={searchStyle} placeholder="请输入公司名称查询" onChange={ModulesAction.onChange}/>
                    <Tree
                        showIcon={true}
                        defaultExpandAll={true}
                        onExpand={ModulesAction.onExpand}
                        expandedKeys={this.modulesState.expandedKeys}
                        autoExpandParent={this.modulesState.autoExpandParent}
                        onSelect={(expandedKeys) => ModulesAction.onSelect(expandedKeys)}
                    >
                        {/* <TreeNode icon={<Icon type="wendang" />} title={companyInfo && companyInfo.name} key="0-0"> */}
                            {this.renderTreeNodes(this.getNewTree(this.modulesState.treeDate))}
                        {/* </TreeNode> */}
                    </Tree>
                </div>}
            </div>
        );
    }
    private renderTreeNodes = (data) => {
        return data && data.map((item) => {
            const index = item.name.indexOf(this.modulesState.searchValue);
            const beforeStr = item.name.substr(0, index);
            const afterStr = item.name.substr(index + this.modulesState.searchValue.length);
            const renderTitle = (stitle, id, sitem) => {
                return (
                    <div className={css['sidebar-treenode']}>
                        <span>{stitle}</span>
                        {item.isCompanyChild && <span className={css.plus} onClick={() => ModulesAction.addCompany(id)}><Icon type="plus"/></span>}
                    </div>
                );
            };
            const title = index > -1 ? (
                <span>
                {beforeStr}
                <span style={{ color: '#f50' }}>{this.modulesState.searchValue}</span>
                {afterStr}
                </span>
            ) : <span>{item.name}</span>;
            if (item.children.length > 0) {
                return (
                    <TreeNode icon={<Icon type="wendang" />} key={item.companyId} title={renderTitle(title, item.companyId, item)}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.companyId} title={renderTitle(title, item.companyId, item)}/>;
        });
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/GroupInfo/UI.Sidebar.tsx